

// Re-export all language-related data from locales/lang.ts
export * from '../locales/lang';
